const isPhone = 576;
const isTablet = 992;

export { isPhone, isTablet };
